import { RendererChartComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/renderer-chart-component';
import CanvasElement from '.';
import { IChartElement } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';

export default class ChartElement extends CanvasElement {
    /**
     * 图表组成元素
     */
    declare public chartElements;

    private chartScaleX;
    private chartScaleY;
    /**
     * 通过统一渲染层组件，给element赋值。
     * @param view 统一渲染层组件
     */
    public applyElementWithDisplayObject(view: RendererChartComponent): ChartElement {
        const { x, y, width, height } = view.worldBounds;
        this.rect = { x, y, width, height };

        // eslint-disable-next-line @typescript-eslint/dot-notation,dot-notation
        this.id = view['id'];
        this.cursor = view.cursor;
        this.alpha = view.alpha;
        this.visible = view.visible;

        this.scaleX = view.scaleX;
        this.scaleY = view.scaleY;
        this.angle = view.angle;
        this.translateX = view.x;
        this.translateY = view.y;

        this.filters = view.filters;

        const { chartComponent, chartTitleComponent } = view;
        const chartElements = chartComponent?.getChartElements?.() ?? [];
        this.chartScaleX = chartComponent.width / this.rect.width;
        this.chartScaleY = chartComponent.height / this.rect.height;
        this.chartElements = {
            xAxis: this.formartElement(chartElements.filter(ele => ele.type === 'axis-label' && ele.extra?.dim === 'x')[0]),
            yAxis: this.formartElement(chartElements.filter(ele => ele.type === 'axis-label' && ele.extra?.dim === 'y')[0]),
            legend: this.formartElement(chartElements.filter(ele => ele.type === 'legend')[0]),
            title: chartTitleComponent
                ? {
                    rect: {
                        x: chartTitleComponent.worldBounds.x,
                        y: chartTitleComponent.worldBounds.y,
                        width: chartTitleComponent.worldBounds.width,
                        height: chartTitleComponent.worldBounds.height,
                    },
                }
                : null,
        };
        return this;
    }

    private formartElement(chartElement: IChartElement) {
        if (!chartElement) return null;
        return {
            rect: {
                x: (chartElement.rect.left / this.chartScaleX) + this.rect.x,
                y: (chartElement.rect.top / this.chartScaleY) + this.rect.y,
                width: chartElement.rect.width / this.chartScaleX,
                height: chartElement.rect.height / this.chartScaleY,
            },
        };
    }
}
